import React from "react";
import SectorCRUDTable from "@/components/SectorCRUDTable";
import { CalendarClock } from "lucide-react";

const STATUS_LABELS = { confirme: "Confirmé", termine: "Terminé", annule: "Annulé", no_show: "No-show" };
const STATUS_COLORS = { confirme: "#002FA7", termine: "#059669", annule: "#868E96", no_show: "#E60000" };

export default function ChefRDV() {
  return (
    <SectorCRUDTable
      endpoint="/chef/secteur/rdv"
      eyebrow="Salon · Rendez-vous"
      title="Agenda des rendez-vous"
      sub="Gérez les rendez-vous clients : prestations, durée, prix."
      testidPrefix="rdv"
      allowEdit
      defaultRow={() => ({ client_nom: "", client_telephone: "", prestation: "", date_heure: new Date().toISOString().slice(0, 16), duree_min: 30, praticien: "", status: "confirme", prix: 0, notes: "" })}
      columns={[
        { key: "date_heure", label: "Date", width: "180px", render: (v) => v ? new Date(v).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "—" },
        { key: "client_nom", label: "Client" },
        { key: "prestation", label: "Prestation" },
        { key: "praticien", label: "Praticien", width: "140px" },
        { key: "duree_min", label: "Durée", width: "80px", render: (v) => `${v} min` },
        { key: "prix", label: "Prix", width: "100px", render: (v) => <span className="font-mono">{(v || 0).toFixed(2)} €</span> },
        { key: "status", label: "Statut", width: "120px", render: (v) => (
          <span className="text-[10px] uppercase font-bold px-2 py-0.5" style={{ color: STATUS_COLORS[v], background: `${STATUS_COLORS[v]}15` }}>{STATUS_LABELS[v] || v}</span>
        )},
      ]}
      fields={[
        { key: "client_nom", label: "Nom client", span: 6, required: true },
        { key: "client_telephone", label: "Téléphone", span: 6 },
        { key: "prestation", label: "Prestation", span: 8, required: true, placeholder: "Coupe + couleur, massage relaxant…" },
        { key: "praticien", label: "Praticien", span: 4 },
        { key: "date_heure", label: "Date & heure", type: "datetime-local", span: 6, required: true },
        { key: "duree_min", label: "Durée (min)", type: "number", span: 3 },
        { key: "prix", label: "Prix (€)", type: "number", step: "0.01", span: 3 },
        { key: "status", label: "Statut", type: "select", span: 6, options: Object.entries(STATUS_LABELS).map(([v, l]) => ({ value: v, label: l })) },
        { key: "notes", label: "Notes", type: "textarea", span: 12 },
      ]}
      emptyIcon={CalendarClock}
      emptyText="Aucun rendez-vous. Cliquez sur Ajouter."
    />
  );
}
